import { LitElement, html, css } from "lit";

export class UpdateModal extends LitElement {
  static styles = css`
    :host {
      position: fixed;
      inset: 0;
      display: none;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.55);
      backdrop-filter: blur(6px);
      z-index: 99999;
    }

    :host([open]) {
      display: flex;
    }

    .modal {
      background: rgba(255, 255, 255, 0.08);
      border-radius: 16px;
      padding: 24px 32px;
      width: 320px;
      text-align: center;
      color: white;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
    }

    button {
      margin-top: 20px;
      padding: 10px 20px;
      border-radius: 8px;
      border: none;
      background: #4da3ff;
      color: white;
      font-size: 16px;
      cursor: pointer;
    }
  `;

  constructor() {
    super();
    this._onUpdateAvailable = this._onUpdateAvailable.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("pwa-update-available", this._onUpdateAvailable);
  }

  disconnectedCallback() {
    document.removeEventListener(
      "pwa-update-available",
      this._onUpdateAvailable,
    );
    super.disconnectedCallback();
  }

  _onUpdateAvailable() {
    this.setAttribute("open", "");
  }

  _reload() {
    navigator.serviceWorker.getRegistration().then((reg) => {
      if (reg?.waiting) {
        reg.waiting.postMessage("SKIP_WAITING");
      } else {
        window.location.reload();
      }
    });
  }

  render() {
    return html`
      <div class="modal">
        <h3>Update Available</h3>
        <p>A new version of Slidey is ready.</p>
        <button @click=${this._reload}>Reload Now</button>
      </div>
    `;
  }
}

customElements.define("update-modal", UpdateModal);
